/**
 * The labels from the Ad Break Pop Up Component
 * @readonly
 * @static
 * @type {Object}
 */
export const ABPU_LABELS = {
  midrolls: {
    title: 'Midrolls rules',
  },
  overlays: {
    title: 'Overlays rules',
  },
  postrolls: {
    title: 'Postrolls rules',
  },
  prerolls: {
    title: 'Prerolls rules',
  },
};

/**
 * The description from the App Component
 * @readonly
 * @static
 * @type {String}
 */
export const APP_DESCRIPTION =
  'The Instream Video Showcase by Equativ helps you discover all our Instream Ad capabilities. Validate your ad tag, explore the Equativ Video Plugin features and leverage our debugging and data insights tools. We are constantly improving our tool so stay tuned for incoming features!';
export const AR_DESCRIPTION =
  'With ad rules, you can adapt the frequency and size of ad breaks to your content duration. We have put some default values to let you try it out. For more information, please refer to our <a target="_blank" href="http://documentation.smartadserver.com/video/configuration/adrules.html">documentation</a>.';
export const CONF_FORMAT =
  'Enter the basic information of your format settings. For more information, please refer to our <a href="http://documentation.smartadserver.com/video/configuration/adpluginconfiguration.html#format" target="_blank">documentation</a>.';
export const CONF_PLAYER =
  'The Player section is related to which controls you want the video player to offer. For more information, please refer to our <a href="http://documentation.smartadserver.com/video/configuration/adpluginconfiguration.html#player" target="_blank">documentation</a>.';
export const CONF_PUBLISHER =
  'You can customize Equativ Video Plugin to fit your specific needs. The parameters are divided into several sections. The Publisher section is related to the end-user experience. For more information, please refer to our <a href="http://documentation.smartadserver.com/video/configuration/adpluginconfiguration.html#publisher" target="_blank" >documentation</a>.';
export const CONF_LABELS =
  'When you integrate the Equativ Video Plugin in your website, the labels can be defined for each supported language. For more information, please refer to our <a href="http://documentation.smartadserver.com/video/configuration/adpluginconfiguration.html#labels" target="_blank">documentation</a>.';
export const CONF_RTB =
  'These options only apply to RTB+ Video insertions. They are meant to better qualify the bid requests sent to buyers, and so improve valuation of the inventory. For more information, please refer to our <a href="http://documentation.smartadserver.com/video/configuration/adpluginconfiguration.html#rtb" target="_blank">documentation</a>.';
export const CONF_VPAID =
  'These options only apply to VPAID creatives. For more information, please refer to our <a href="http://documentation.smartadserver.com/video/configuration/adpluginconfiguration.html#vpaid" target="_blank">documentation</a>.';
export const OTHER_USER =
  'Enrich the ad call with a 1st-party user identifier that Equativ platform can leverage for user-related features. For more information, please refer to our <a href="https://documentation.smartadserver.com/video/html5/integration.html#user" target="_blank">documentation</a>.';
export const OTHER_CONTENT =
  'With Content Data data you can pass to the adserver data describing your video content. For more information, please refer to our <a href="http://documentation.smartadserver.com/video/configuration/contentdata.html" target="_blank">documentation</a>.';

/**
 * The title from the Embedded Player Component
 * @readonly
 * @static
 * @type {String}
 */
export const EP_TITLE = 'Player panel';

/**
 * The title from the LogPanel Component
 * @readonly
 * @static
 * @type {String}
 */
export const LP_TITLE = 'Test Output';

export const COMPANION_TITLE = 'Companion ad preview';
export const COMPANION_DESCRIPTION = 'Select the companion ad size.';

export const PD_DESCRIPTION =
  'Enter the basic information of your online advertising. We have put some default values to let you try it out. For more information, please refer to our <a target="_blank" href="http://documentation.smartadserver.com/video/html5/integration.html#placement">documentation</a>.';

export const PD_BANNER_DESCRIPTION =
  'You can also enter information about a banner advertising that will be displayed when the player is pausing, please refer to our <a target="_blank" href="http://documentation.smartadserver.com/video/configuration/adpluginconfiguration.html#banner">documentation</a>';

/**
 * The array of labels for the tab buttons from the SectionPanel Component
 * @readonly
 * @static
 * @type {Array of Strings}
 */
export const SP_BTN_LABELS = ['VAST Inspector', 'Plugin Settings', 'Output'];

/**
 * The initial text in the textbox from the VastForm Component
 * @readonly
 * @static
 * @type {String}
 */
export const VF_INIT_AREA = 'Please enter VAST tag or VAST XML';

/**
 * The initial select option from the vast samples
 * @readonly
 * @static
 * @type {String}
 */
export const INIT_VAST_SAMPLE = '-- Please choose a sample --';

/**
 * The initial text in the textbox from the Import Settings
 * @readonly
 * @static
 * @type {String}
 */
export const SP_IMPORT_INIT_AREA = 'Paste your settings here';

/**
 * The description from the VastInspector Component
 * @readonly
 * @static
 * @type {String}
 */
export const VI_DESCRIPTION =
  'Use our VAST inspector to verify whether your ad response will be correctly parsed by our Instream Video solutions. You can either paste the VAST ad tag or the VAST payload. Start the test to see the ad being played as an preroll* in the video player and the events / errors in the logs below the player';
export const VI_DESCRIPTION_PART2 =
  '*To test other ad breaks types like overlays, midrolls, postrolls please use section Plugin Settings';
